'use client'

import { useState, useEffect } from 'react';
import { logger } from '@/utils/logger';
import { storage } from '@/utils/storage';

export function StorageDebug() {
  const [isVisible, setIsVisible] = useState(false);
  const [storageStatus, setStorageStatus] = useState<any>(null);
  const [logs, setLogs] = useState<any[]>([]);

  useEffect(() => {
    // Only show if debug mode is enabled
    if (!logger.isDebugMode()) return;

    setIsVisible(true);

    // Check storage availability
    const checkStorage = async () => {
      const status = await storage.isStorageAvailable();
      setStorageStatus(status);
    };

    checkStorage();

    // Update logs every 2 seconds
    const interval = setInterval(() => {
      const latestLogs = logger.getLogs().slice(-10); // Last 10 logs
      setLogs(latestLogs);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  if (!isVisible) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        bottom: '10px',
        right: '10px',
        width: '400px',
        maxHeight: '300px',
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        color: 'white',
        padding: '10px',
        borderRadius: '8px',
        fontSize: '12px',
        fontFamily: 'monospace',
        overflow: 'auto',
        zIndex: 9999,
        border: '1px solid #333'
      }}
    >
      <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>
        🔍 Storage Debug Panel
        <button 
          onClick={() => setIsVisible(false)}
          style={{ 
            float: 'right', 
            background: 'none', 
            border: 'none', 
            color: 'white', 
            cursor: 'pointer' 
          }}
        >
          ✕
        </button>
      </div>
      
      {storageStatus && (
        <div style={{ marginBottom: '10px' }}>
          <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>Storage Status:</div>
          <div>localStorage: {storageStatus.localStorage ? '✅' : '❌'}</div>
          <div>sessionStorage: {storageStatus.sessionStorage ? '✅' : '❌'}</div>
          <div>IndexedDB: {storageStatus.indexedDB ? '✅' : '❌'}</div>
          <div>Cookies: {storageStatus.cookies ? '✅' : '❌'}</div>
        </div>
      )}

      <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>Recent Logs:</div>
      <div style={{ maxHeight: '150px', overflow: 'auto' }}>
        {logs.map((log, index) => (
          <div 
            key={index} 
            style={{ 
              marginBottom: '2px',
              color: log.level === 'error' ? '#ff6b6b' : 
                    log.level === 'warn' ? '#ffa726' : 
                    log.level === 'info' ? '#42a5f5' : '#ccc'
            }}
          >
            <span style={{ color: '#888' }}>
              {new Date(log.timestamp).toLocaleTimeString()}
            </span>
            {' '}
            <span style={{ color: '#4fc3f7' }}>[{log.component}]</span>
            {' '}
            {log.message}
          </div>
        ))}
      </div>

      <div style={{ marginTop: '10px', fontSize: '10px', color: '#888' }}>
        Add ?debug=true to URL to enable debug mode
      </div>
    </div>
  );
}